export default class UpdateAdvertiseDates {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.form = document.getElementById('updateAdDates');

    if (!this.form) return;

    this.action = this.form.getAttribute('action');
    this.elements = this.form.elements;

    return true;
  }

  setupEvents() {
    this.form.addEventListener('submit', (evt) => this.handleSubmit(evt));
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const data = this.buildData();
    this.send(data);
  }

  buildData() {
    let data = new FormData();

    for (let i = 0; i < this.elements.length; i++) {
      const el = this.elements[i];

      if (el.getAttribute('type') !== 'submit') {
        const key = el.getAttribute('name');
        const val = (el.value !== 'placeholder') ? el.value : '';
        data.append(key, val);
      }
    }

    return data;
  }

  send(data) {
    axios.post(this.action, data)
    .then((response) => {
      if (response && response.data.code === 200) {
        window.location.assign(response.data.payload.redirect);
      } else {
        throw new Error(response);
      }
    })
    .catch((error) => {
      document._kweber.toast({
        type: 'error',
        title: 'Błąd zapisu, spróbuj ponownie'
      });
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/UpdateAdvertiseDates.js